import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { BarChart } from '@/components/charts/BarChart';
import { useAutomationStats } from '@/hooks/useAdminAutomations';

interface AutomationStatsPayload {
  data?: AutomationStatsPayload;
  dailyStats?: Array<{ date: string; success: number; failed: number }>;
}

export function AutomationStatsChart() {
  const { data: rawData } = useAutomationStats('7d');
  const typedData = rawData as AutomationStatsPayload | undefined;
  const statsRoot = typedData?.data ?? typedData;
  const dailyStats = Array.isArray(statsRoot?.dailyStats) ? statsRoot.dailyStats : [];
  const chartData = dailyStats.map((d) => ({
    date: d.date,
    success: d.success,
    failed: d.failed,
  }));

  return (
    <Card>
      <CardHeader title="Exécutions (7 derniers jours)" />
      <CardContent>
        <BarChart
          data={chartData}
          bars={[
            { key: 'success', color: '#22c55e', label: 'Succès' },
            { key: 'failed', color: '#ef4444', label: 'Échecs' },
          ]}
          height={250}
          stacked
        />
      </CardContent>
    </Card>
  );
}
